var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124.139,
    height: 124.139,
    viewBox: "0 0 124.139 124.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_9654"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.459,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149794",
    "data-name": "Group 149794",
    transform: "translate(-897.93 -289.343)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 897.93, 289.34)",
    filter: "url(#Ellipse_9654)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9654-2",
    "data-name": "Ellipse 9654",
    cx: 51,
    cy: 51,
    r: 51,
    transform: "translate(11.07 10.66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9654-3",
    "data-name": "Ellipse 9654",
    cx: 51,
    cy: 51,
    r: 51,
    transform: "translate(909 300)",
    fill: "none",
    stroke: "#156745",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149715",
    "data-name": "Group 149715",
    transform: "translate(981.396 372.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149714",
    "data-name": "Group 149714",
    transform: "translate(-83.466 -83.413)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9653",
    "data-name": "Ellipse 9653",
    cx: 43.89,
    cy: 43.89,
    r: 43.89,
    transform: "translate(0 62.07) rotate(-45)",
    fill: "#098551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102392",
    "data-name": "Path 102392",
    d: "M185.588,149.776a43.925,43.925,0,0,1-35.812,35.812l-23.627-23.627a25.44,25.44,0,1,1,35.812-35.812Z",
    transform: "translate(-80.251 -80.261)",
    fill: "#156745",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102393",
    "data-name": "Path 102393",
    d: "M130.423,143.841l7.245,6.653a2.643,2.643,0,0,0,3.687-.1l12.925-12.375a2.642,2.642,0,0,0-3.662-3.808l-11.2,10.719L134,139.951a2.643,2.643,0,0,0-3.579,3.89Zm11.908-26.95a25.439,25.439,0,1,1-25.439,25.439A25.439,25.439,0,0,1,142.33,116.891Z",
    transform: "translate(-80.251 -80.261)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmission);
export default __webpack_public_path__ + "static/media/submission.e9a92cd03e013c6a639f95f5e53c42c4.svg";
export { ForwardRef as ReactComponent };